import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StripeSuccess() {
  const navigate = useNavigate();


  return (
    <div style={{ padding: 32 }}>
      <h2>Payment successful 🎉</h2>
      <p>Your credits will update shortly.</p>
    </div>
  );
}
